import { HardwareProduct } from '@shared/models/hardware-product.model';
import { Selector } from '@ngxs/store';
import { CustomerProductHardwareState, CustomerProductsAccessoryStateModel } from './accessory-product.state';
import { CustomerProductSelectors } from '../customer-product/customer-product.selectors';
import { VoiceProduct } from '@app/shared/models/voice-product.model';

type VoiceProductAccessoryBundle = {
  connectedVoiceProduct: VoiceProduct;
  connectedAccessoryProduct: HardwareProduct;
};

export class CustomerProductsAccessorySelectors {
  @Selector([CustomerProductHardwareState])
  static getState(state: CustomerProductsAccessoryStateModel): CustomerProductsAccessoryStateModel {
    return state;
  }

  @Selector([CustomerProductHardwareState])
  static newAccessoryProducts(state: CustomerProductsAccessoryStateModel): HardwareProduct[] {
    return state.products;
  }

  @Selector([CustomerProductHardwareState])
  static selectedHardwareProductId(state: CustomerProductsAccessoryStateModel): string {
    return state.selectedHardwareId;
  }

  @Selector([CustomerProductSelectors.bundledVoiceProducts, CustomerProductsAccessorySelectors.newAccessoryProducts])
  static getAccessoryBundles(
    connectedVoiceProducts: VoiceProduct[],
    newAccessoryProducts: HardwareProduct[]
  ): VoiceProductAccessoryBundle[] {
    return newAccessoryProducts
      .filter(accessoryProduct => Boolean(accessoryProduct.voiceProductId))
      .map(accessoryProduct => {
        return {
          connectedVoiceProduct: connectedVoiceProducts?.find(x => x.id === accessoryProduct.voiceProductId),
          connectedAccessoryProduct: accessoryProduct,
        };
      });
  }
}
